import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import StudentKiosk from './pages/StudentKiosk';
import StaffLogin from './pages/StaffLogin';
import StaffDashboard from './pages/StaffDashboard';
import DisplayScreen from './pages/DisplayScreen';
import ReportViewer from './pages/ReportViewer';
import TicketView from './pages/TicketView';
import './App.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error('App error:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 40, textAlign: 'center' }}>
          <h2>Xatolik yuz berdi</h2>
          <p>Iltimos, sahifani yangilang.</p>
          <button onClick={() => window.location.reload()}
            style={{ padding: '10px 20px', fontSize: 16, cursor: 'pointer' }}>
            Yangilash
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <div className="App">
          <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false}
            closeOnClick draggable pauseOnHover />
          <Routes>
            <Route path="/" element={<Navigate to="/student" replace />} />
            <Route path="/student" element={<StudentKiosk />} />
            <Route path="/ticket/:ticketId" element={<TicketView />} />
            <Route path="/staff/login" element={<StaffLogin />} />
            <Route path="/staff/dashboard" element={<StaffDashboard />} />
            <Route path="/staff/reports" element={<ReportViewer />} />
            <Route path="/display/:facultyId" element={<DisplayScreen />} />
          </Routes>
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
